<template>
  <div class="main" v-loading="loading">
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>模块更新</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-collapse  accordion>
  <el-collapse-item title="最后更新时间" name="aa">
  <div style="margin-top:20px;">
    <el-table :data="lastData" style="width: 100%">
    <el-table-column label="类型" prop="type">
    </el-table-column>
     <el-table-column label="最后数据" prop="name">
    </el-table-column>
     <el-table-column label="时间" prop="date">
    </el-table-column>
    </el-table>
    
  </div>
  </el-collapse-item>
    </el-collapse>
 
  <div style="margin-top:60px;">
    <el-table :data="chartList" style="width: 100%">

    <el-table-column label="标题" prop="title">
    </el-table-column>
    
    
    <el-table-column label="显示记录数" prop="count"></el-table-column> 
 
    <el-table-column label="最后更新" prop="lastUpdated">

       <template slot-scope="scope">    
       {{ scope.row.lastUpdated| formatDate }}
       </template>
    </el-table-column>
    <el-table-column label="类型">
       <template slot-scope="scope">   
          <el-radio-group   :value="scope.row.updateOption" size="mini" @change="chooseType(scope.$index, scope.row)">
    <el-radio :label="1">自动更新</el-radio>
    <el-radio :label="2">手动更新</el-radio>
 
  </el-radio-group>
       </template>
    </el-table-column>
    <el-table-column align="right" label="操作">   
      <template slot-scope="scope">
        <el-button size="mini"  @click="handleEdit(scope.$index, scope.row)">编辑数据</el-button>
        <el-button size="mini" type="danger" @click="handleBuild(scope.$index, scope.row)">拉取</el-button>
      </template>
    </el-table-column>
  </el-table>
  </div>

 <el-dialog :title="currentRow.title"
            :visible.sync="showDialog"
            :center="false"
            :append-to-body="true" v-loading="isLoading">
            <span slot="dialog-title">编辑 {{currentRow.title}}</span>
            <div>
              <el-input type="textarea" v-model="currentRow.jsonData" rows="10"></el-input>
            </div>
            <div style="margin-top:10px;">
       <el-input type="text" placeholder="请输入跳转地址"  v-model="currentRow.url" />
            </div>
  
            <span slot="footer">
                <el-button @click="cancel">取消</el-button>
                <el-button @click="saveChart" type="primary">更新</el-button>
            </span>
        </el-dialog>
  
  </div>
</template>

<script>
import { mapMutations, mapGetters, mapActions, mapState } from "vuex";
import Permissions from  '../../store/permissions.js'
import {formatDate,strToFormatDate,strToYeayAndMonth } from '@/plugins/DateTimeFormater.js';
import XLSX from "xlsx";
export default {
  name: "dailyreport",

  data() {
    return {
      updateOption:1,
      loading: false,
      showDialog:false,
      currentRow:{}

    }
  },
  methods: {
  ...mapActions('home', ['queryChartConfigs','queryChartUpdate' ,'getLastData','queryChartBuild'  ]),
   handleEdit(index, row) {
        console.log(index, row);
        this.currentRow = row;
        this.showDialog = true;
      },
      handleBuild(index, row) {
        console.log(index, row);
        self = this;
        this.showDialog = true;
        var postData = {'chartName':row.name,'noCache':true};//'chartName='+row.name; //
        this.queryChartBuild({params:postData,handle:function(res){
          row.jsonData =JSON.stringify( res.data);
          if(res.url)
          {
          row.url = res.url;
           }
        
          row.lastUpdated =res.updated;
          self.currentRow = row;
        }});

      },
      chooseType(index, row) {
        if(row.title=='整体市场分省份销量分布(new)')
        {
          this.$message({ message: '该类型不可更改！', duration: 2000 });
          return;
        }
         row.updateOption = row.updateOption ==1?2:1;
        console.log(index, row);

         this.queryChartUpdate({handle:this.updateHandle,params:row});
       this.showDialog = false;
       var msg= `您更换模块《${row.title}》 为 ${this.chartOption(row.updateOption)}`;
       this.$message({ message: msg, duration: 2000 });
      },
      cancel(){
        this.showDialog = false;

      },

     saveChart(){
       this.queryChartUpdate({handle:this.updateHandle,params:this.currentRow});
       this.showDialog = false;
       this.$message({ message: "保存成功", duration: 2000 });
     },
     updateHandle(res)
     {
       
      // alert(JSON.stringify(res));
     }
  },

  computed: {
      ...mapState({
        isLoading: state => state.loadingCount > 0
      }),
 ...mapGetters('home', {'chartList':'chartList' ,'lastData':'lastData'}),
    chartOption(){
      return function(num){
          if(num==2)
             return '手动更新'
             return '自动更新'
      }
    }
  },
  mounted(){
       this.queryChartConfigs({cb:null});
       this.getLastData({handle:null});

  },
  watch: {
   
  },
  filters:{
    formatDate(dt)
    {
       return formatDate(new Date( dt));
    }
  }
};
</script>
<style .scoped>
 
</style>